import { PtwLearningPage } from './PtwLearningPage'
import { tutorialContent } from './tutorial-data'
import type { PtwLearningPageProps } from './types'

export type LearningPageProps = Omit<PtwLearningPageProps, 'content'>

/** Self-contained reading/practice module; the host owns any platform navigation. */
export function LearningPage(props: LearningPageProps) {
  return (
    <PtwLearningPage
      key={`${tutorialContent.version}:${props.initialStepId ?? props.initialLessonId ?? 'default'}`}
      content={tutorialContent}
      embedded
      {...props}
    />
  )
}

export { PtwLearningPage, tutorialContent }
export type { TutorialContent } from './types'
